import {Component} from '@angular/core';
import {Block}     from "../../block";

@Component({
    selector   : 'app-featured-person',
    templateUrl: './featured-person.component.html',
})
export class FeaturedPersonComponent extends Block {

}
